// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6a7aed4e","114":"f9db0a95","243":"46d5c1ec","554":"ef99f6bc","787":"123e2fb2"}[chunkId] + ".chunk.js";
};